module.exports = __webpack_public_path__ + "static/media/alchemist.9a78feb4.mp3";